import RoleHome from '../RoleHome';

export default function LabTechnicianPage() {
  return (
    <RoleHome
      title="Lab technician"
      description="Laboratory requests and results."
    />
  );
}
